import styled from "styled-components";
import Card from "react-bootstrap/Card";

import backgroundPage from "../../../image/purchase/background-subscription.png";

export const SubscriptionBackground = styled.section`
  background: url(${backgroundPage}) no-repeat;
  background-size: cover;
`;
export const StyledCard = styled(Card)`
  width: 300px;
  height: 360px;
  background: var(--white-color);
  box-shadow: var(--box-shadow1);
  border-radius: 12px;
  @media screen and (max-width: 576px) {
    width: 240px;
    height: 260px;
  }
  p {
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: var(--blue-color-dark);
  }
  img {
    @media screen and (max-width: 576px) {
      width: 150px;
    }
  }
  &:hover {
    background: var(--field-color);
    box-shadow: 1px 10px 30px rgba(34, 91, 148, 0.32),
      inset 5px 15px 30px #225b94;
    p {
      font-size: var(--font-size-lg);
      color: var(--white-color);
    }
  }
`;
